import * as z from "zod";

export const getCatalogTags = {
  name: "getCatalogTags" as const,
  input: z.object({ search: z.string().optional() }),
  output: z.object({ tags: z.array(z.string()) }),
};
